module.exports = __webpack_public_path__ + "static/media/Ediths_plot_desktop_article_7.910c16bf.jpg";